<template>
  <div class="wrap">
    <div class="main">
      <textarea
          class="fill-textarea"
          v-model="desc"
          maxlength="100"
          name=""
          id=""
          cols="30"
          rows="10"
          placeholder="请输入内容"
        ></textarea>
      
    </div>
    <div class="btn"  @click="save">
        提交
    </div>
    <div class="btn"  @click="cancel">
        撤回投诉
    </div>
  </div>
</template>
<script>
import { getToken, reLogin } from "@/utils/common";
import questionOnly from "@/utils/questionOnly";
import { Toast } from "vant";
export default {
  data() {
    return {
      appeal_name: "权益未生效",
      desc: "",
      imgs: [],
      order_id: "6627315f5c5474426cb107bc",
      appeal_id: ''
    };
  },
  mounted() {
    if(this.$route.query.no) {
      this.order_id = this.$route.query.no;
      this.getDetail();
    }
  },
  methods: {
    save() {
      if (this.desc == "") {
        return Toast("请填写留言内容");
      }
      let param = {
        order_id: this.order_id,
        appeal_id: this.appeal_id,
        desc: this.desc,
        ...(this.imgs && this.imgs.length ? { imgs: this.imgs } : {}),
        access_token: getToken()
      };
      questionOnly.post("/xcx/ques/v1/order/appeal/leave", param).then(res => {
        if (res.sta == 0) {
          Toast("提交成功");
          this.getDetail()
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    cancel() {
      let param = {
        order_id: this.order_id,
        appeal_id: this.appeal_id,
        access_token: getToken()
      };
      questionOnly.post("/xcx/ques/v1/order/appeal/recall", param).then(res => {
        if (res.sta == 0) {
          Toast("投诉撤回成功");
          this.getDetail();
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    },
    getDetail() {
      let param = {
        order_id: this.order_id,
        page: 1,
        count: 20,
        access_token: getToken(),
      }
      questionOnly.get("/xcx/ques/v1/order/appeal/detail", param).then(res => {
        if (res.sta == 0) {
          this.appeal_id = res.data.appeal_id;
        } else if (res.sta === -500) {
          reLogin();
        } else {
          Toast(res.msg);
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.main {
  margin: 10px 15px;
  background: #fff;

}
.fill-textarea {
  border: 0;
  font-size: 14px;
  width: 100%;
  height: 80px;
  padding: 10px;
}
.btn {
  height: 43px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  background: #1890FF;
  font-size: 17px;
  margin: 15px;
}

</style>



// WEBPACK FOOTER //
// src/pages/order/message.vue